import React from 'react'
import { WEBSITE } from './commonFunction';

const CustomPopup = ({ actionHandler, message }) => {
    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>

            <div className='delete-popup-main' style={{top:'13%'}}>
                <p className='text'>{message}</p>
                <hr />
                {
                    message === "Thank you for filling out your loan information!" ||  message === "Link is Expired!" ?
                        <div className="text-end">
                           <a href={WEBSITE}> <button type="button" className="cred-btn" onClick={e => actionHandler('yes')}>Okay</button></a>
                        </div>
                        :
                        <div className="text-end">
                            <button type="button" className="cred-btn" onClick={e => actionHandler('yes')}>Yes</button>
                            <button type="button" className="cred-btn cancel-btn" onClick={e => actionHandler('no')}>No</button>
                        </div>}
            </div>
        </div>
    )
}

export default CustomPopup;